var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"breadcrumb"},[_c('b',[_c('router-link',{staticStyle:{"color":"#000"},attrs:{"to":'/general-settings'}},[_vm._v(" "+_vm._s(_vm.enterpriseName)+" ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }